// extracted by mini-css-extract-plugin
export default {"label":"styles_label__9QckY","container":"styles_container__Ye8jd"};